<template>
    <v-container fluid grid-list-xl>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div>
            <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE DESKTOP -->
            <section v-responsive.lg.xl>
              <div class="paralax-cover-image has-background-dim">
                <div class="paralax-cover-image-text">
                  <div class="content_home" style="z-index: 1!important;margin-top: 30%;">
                    <h1 style="font-size: 70px" class="font-weight-bold"><span>{{ $t('home_page.Home_titre') }}</span></h1>
           
                      
                      <div class="container_animation">
                          <h1 class="rotating-text"><span class="nowrap">
                              <span class="window">
                                <div class="window-inner">
                                  <span>{{ $t('home_page.Home_titre_2[0]') }}<br /></span>
                                  <span>{{ $t('home_page.Home_titre_2[1]') }}<br /></span>
                                  <span>{{ $t('home_page.Home_titre_2[2]') }}<br /></span>
                                  <span>{{ $t('home_page.Home_titre_2[3]') }}<br /></span>
                                </div>
                              </span>
                            </span>
                          </h1>
                        </div>
                        

                    <p>{{ $t('home_page.Descriptif_message[0]') }}<br> {{ $t('home_page.Descriptif_message[1]') }}</p>
                    <div class="row">
                      <div class="trigger ml-3 mt-4">
                        <span>
                          <img class="mr-3" loading="lazy" src="../assets/img/writing.png" width="25px"  alt="writing quotes">
                          <!-- <svg class="mr-3" width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9436 1.25H13.0564C14.8942 1.24998 16.3498 1.24997 17.489 1.40314C18.6614 1.56076 19.6104 1.89288 20.3588 2.64124C20.6516 2.93414 20.6516 3.40901 20.3588 3.7019C20.0659 3.9948 19.591 3.9948 19.2981 3.7019C18.8749 3.27869 18.2952 3.02502 17.2892 2.88976C16.2615 2.75159 14.9068 2.75 13 2.75H11C9.09318 2.75 7.73851 2.75159 6.71085 2.88976C5.70476 3.02502 5.12511 3.27869 4.7019 3.7019C4.27869 4.12511 4.02502 4.70476 3.88976 5.71085C3.75159 6.73851 3.75 8.09318 3.75 10V14C3.75 15.9068 3.75159 17.2615 3.88976 18.2892C4.02502 19.2952 4.27869 19.8749 4.7019 20.2981C5.12511 20.7213 5.70476 20.975 6.71085 21.1102C7.73851 21.2484 9.09318 21.25 11 21.25H13C14.9068 21.25 16.2615 21.2484 17.2892 21.1102C18.2952 20.975 18.8749 20.7213 19.2981 20.2981C19.994 19.6022 20.2048 18.5208 20.2414 15.9892C20.2474 15.575 20.588 15.2441 21.0022 15.2501C21.4163 15.2561 21.7472 15.5967 21.7412 16.0108C21.7061 18.4383 21.549 20.1685 20.3588 21.3588C19.6104 22.1071 18.6614 22.4392 17.489 22.5969C16.3498 22.75 14.8942 22.75 13.0564 22.75H10.9436C9.10583 22.75 7.65019 22.75 6.51098 22.5969C5.33856 22.4392 4.38961 22.1071 3.64124 21.3588C2.89288 20.6104 2.56076 19.6614 2.40314 18.489C2.24997 17.3498 2.24998 15.8942 2.25 14.0564V9.94358C2.24998 8.10582 2.24997 6.65019 2.40314 5.51098C2.56076 4.33856 2.89288 3.38961 3.64124 2.64124C4.38961 1.89288 5.33856 1.56076 6.51098 1.40314C7.65019 1.24997 9.10582 1.24998 10.9436 1.25ZM18.1131 7.04556C19.1739 5.98481 20.8937 5.98481 21.9544 7.04556C23.0152 8.1063 23.0152 9.82611 21.9544 10.8869L17.1991 15.6422C16.9404 15.901 16.7654 16.076 16.5693 16.2289C16.3387 16.4088 16.0892 16.563 15.8252 16.6889C15.6007 16.7958 15.3659 16.8741 15.0187 16.9897L12.9351 17.6843C12.4751 17.8376 11.9679 17.7179 11.625 17.375C11.2821 17.0321 11.1624 16.5249 11.3157 16.0649L11.9963 14.0232C12.001 14.0091 12.0056 13.9951 12.0102 13.9813C12.1259 13.6342 12.2042 13.3993 12.3111 13.1748C12.437 12.9108 12.5912 12.6613 12.7711 12.4307C12.924 12.2346 13.099 12.0596 13.3578 11.8009C13.3681 11.7906 13.3785 11.7802 13.3891 11.7696L18.1131 7.04556ZM20.8938 8.10622C20.4188 7.63126 19.6488 7.63126 19.1738 8.10622L18.992 8.288C19.0019 8.32149 19.0132 8.3571 19.0262 8.39452C19.1202 8.66565 19.2988 9.02427 19.6372 9.36276C19.9757 9.70125 20.3343 9.87975 20.6055 9.97382C20.6429 9.9868 20.6785 9.99812 20.712 10.008L20.8938 9.8262C21.3687 9.35124 21.3687 8.58118 20.8938 8.10622ZM19.5664 11.1536C19.2485 10.9866 18.9053 10.7521 18.5766 10.4234C18.2479 10.0947 18.0134 9.75146 17.8464 9.43357L14.4497 12.8303C14.1487 13.1314 14.043 13.2388 13.9538 13.3532C13.841 13.4979 13.7442 13.6545 13.6652 13.8202C13.6028 13.9511 13.5539 14.0936 13.4193 14.4976L13.019 15.6985L13.3015 15.981L14.5024 15.5807C14.9064 15.4461 15.0489 15.3972 15.1798 15.3348C15.3455 15.2558 15.5021 15.159 15.6468 15.0462C15.7612 14.957 15.8686 14.8513 16.1697 14.5503L19.5664 11.1536ZM7.25 9C7.25 8.58579 7.58579 8.25 8 8.25H14.5C14.9142 8.25 15.25 8.58579 15.25 9C15.25 9.41421 14.9142 9.75 14.5 9.75H8C7.58579 9.75 7.25 9.41421 7.25 9ZM7.25 13C7.25 12.5858 7.58579 12.25 8 12.25H10.5C10.9142 12.25 11.25 12.5858 11.25 13C11.25 13.4142 10.9142 13.75 10.5 13.75H8C7.58579 13.75 7.25 13.4142 7.25 13ZM7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H9.5C9.91421 16.25 10.25 16.5858 10.25 17C10.25 17.4142 9.91421 17.75 9.5 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z" fill="#fff"></path> </g></svg> -->
                          {{ $t('home_page.bouton_devis[0]') }} <i style="font-size: 20px"
                                                                      class="ml-4 fas fa-chevron-down"></i></span>
                        <ul class="devis elevation-24">
                          <li class="font-weight-bold" style="cursor:pointer;color: #000;">{{ $t('home_page.particulier_label') }}</li>
                          <li><a href="/devis/auto"><i><img   class="mr-2" width="35"
                                                            src="../assets/img/icones/menu/cars_quote.png"
                                                            :alt="$t('home_page.bouton_devis[1]')"/></i>
                            {{ $t('home_page.bouton_devis[1]') }}</a></li>
                          <li><a href="/devis/habitation"><i><img    class="mr-2" width="35"
                                                                  src="../assets/img/icones/menu/house_quote.png"
                                                                  :alt="$t('home_page.bouton_devis[2]')"/></i>
                            {{ $t('home_page.bouton_devis[2]') }}</a></li>
                          <li><a href="/devis/voyage"><i><img   class="mr-2" width="35"
                                                              src="../assets/img/icones/menu/travel_quote.png"
                                                              :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                              $t('home_page.bouton_devis[3]')
                            }}</a></li>
                          <li><a href="/devis/sante"><i><img   class="mr-2" width="35"
                                                            src="../assets/img/icones/menu/health_quote.png"
                                                            :alt="$t('home_page.bouton_devis[4]')"/></i>{{
                              $t('home_page.bouton_devis[4]')
                            }}</a></li>
                          <li><a href="/devis/vie"><i><img   class="mr-2" width="35"
                                                          src="../assets/img/icones/menu/life_quote.png"
                                                          :alt="$t('home_page.bouton_devis[5]')"/></i>{{
                              $t('home_page.bouton_devis[5]')
                            }}</a></li>
                          <li><a href="/plus"><i><img   class="mr-2" width="35" src="../assets/img/icones/menu/add_quote.png"
                                                      :alt="$t('home_page.bouton_devis[6]')"/></i>{{
                              $t('home_page.bouton_devis[6]')
                            }}</a></li>
                          <li class="font-weight-bold" style="cursor:pointer;color: #000;">{{ $t('home_page.entreprise_label') }}</li>
                          <li><a href="/flotte/entreprise"><i><img class="mr-2" width="35" src="../assets/img/icones/menu/cars_quote.png" alt="flotte"/></i>{{ $t('menu.Devis[7]') }}</a></li>
                          <li><a href="/devis/mrp"><i><img   class="mr-2" width="30"
                                                          src="../assets/img/icones/menu/mrp_quote.png"
                                                          alt="devis_mrp"/></i> MRP</a></li>
                          <li><a href="/devis/trc"><i><img   class="mr-2" width="35"
                                                          src="../assets/img/icones/menu/trc_quote.png"
                                                          alt="devis_trc"/></i>TRC</a></li>
                                                          <li><a href="/rcscolaire"><i><img class="mr-2" width="35" src="../assets/img/icones/rcscolaire.png" alt="flotte"/></i>{{ $t('menu.Devis[8]') }}</a></li>
                        </ul>
                      </div>

                      <div class="trigger-simulation ml-4 mt-4">
                        <span>
                          <img class="mr-3" loading="lazy" src="../assets/img/rocket.png" width="25px"  alt="writing quotes">
                          {{ $t('home_page.bouton_simulation_view') }} <i style="font-size: 20px"
                                                                      class="ml-4 fas fa-chevron-down"></i></span>
                        <ul class="devis elevation-24">
                          <li><a href="/simulate/devis/auto"><i><img   class="mr-2" width="35"
                                                            src="../assets/img/icones/menu/cars_quote.png"
                                                            :alt="$t('home_page.bouton_devis[1]')"/></i>
                            {{ $t('home_page.bouton_devis[1]') }}</a></li>
                          <li><a href="/simulate/devis/voyage"><i><img   class="mr-2" width="35"
                                                              src="../assets/img/icones/menu/travel_quote.png"
                                                              :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                              $t('home_page.bouton_devis[3]')
                            }}</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <p style="font-weight: 400; font-size: 15px; padding-top: 30%;">{{ $t('home_page.cima_agree[0]') }} <span style="color: rgb(255, 164, 9);">{{ $t('home_page.cima_agree[1]') }}</span>{{ $t('home_page.cima_agree[2]') }} {{ $t('home_page.cima_agree[3]') }}</p>
                </div>
              </div>
            </section>

            <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE MOBILE -->
            <section style="margin-top:50px" v-responsive.sm.xs>
              <div class="paralax-cover-image_mobile has-background-dim_mobile">
                <div class="paralax-cover-image-text_mobile">
                  <div class="content_home" style="z-index: 1!important;margin-top: 15%;">
                    <h1 style="font-size: 50px" class="font-weight-bold"><span>{{ $t('home_page.Home_titre') }}</span></h1>
                      <div class="container_animation-mobile">
                          <h1 class="rotating-text-mobile"><span class="nowrap-mobile">
                              <span class="window-mobile">
                                <div class="window-inner-mobile">
                                  <span>{{ $t('home_page.Home_titre_2[0]') }}<br /></span>
                                  <span>{{ $t('home_page.Home_titre_2[1]') }}<br /></span>
                                  <span>{{ $t('home_page.Home_titre_2[2]') }}<br /></span>
                                  <span>{{ $t('home_page.Home_titre_2[3]') }}<br /></span>
                                </div>
                              </span>
                            </span>
                          </h1>
                        </div>

                    <p>{{ $t('home_page.Descriptif_message_mobile[0]') }}<br>{{
                        $t('home_page.Descriptif_message_mobile[1]')
                      }}
                      <br> {{ $t('home_page.Descriptif_message_mobile[2]') }}</p>
                    <div class="row">
                      <div class="trigger">
                        <span>
                          <img class="mr-3" loading="lazy" src="../assets/img/writing.png" width="25px"  alt="writing quotes">

                                                  {{ $t('home_page.bouton_devis[0]') }}<i style="font-size: 18px"
                                                                      class="ml-3 fas fa-chevron-down"></i></span>
                        <ul class="devis elevation-24" style="z-index:2">
                          <li class="font-weight-bold" style="cursor:pointer;color: #000;">{{ $t('home_page.particulier_label') }}</li>
                          <li><a href="/devis/auto"><i><img   class="mr-2" width="35"
                                                            src="../assets/img/icones/menu/cars_quote.png"
                                                            :alt="$t('home_page.bouton_devis[1]')"/></i>
                            {{ $t('home_page.bouton_devis[1]') }}</a></li>
                          <li><a href="/devis/habitation"><i><img   class="mr-2" width="35"
                                                                  src="../assets/img/icones/menu/house_quote.png"
                                                                  :alt="$t('home_page.bouton_devis[2]')"/></i>
                            {{ $t('home_page.bouton_devis[2]') }}</a></li>
                          <li><a href="/devis/voyage"><i><img   class="mr-2" width="35"
                                                              src="../assets/img/icones/menu/travel_quote.png"
                                                              :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                              $t('home_page.bouton_devis[3]')
                            }}</a></li>
                          <li><a href="/devis/sante"><i><img   class="mr-2" width="35"
                                                            src="../assets/img/icones/menu/health_quote.png"
                                                            :alt="$t('home_page.bouton_devis[4]')"/></i>{{
                              $t('home_page.bouton_devis[4]')
                            }}</a></li>
                          <li><a href="/devis/vie"><i><img   class="mr-2" width="35"
                                                          src="../assets/img/icones/menu/life_quote.png"
                                                          :alt="$t('home_page.bouton_devis[5]')"/></i>{{
                              $t('home_page.bouton_devis[5]')
                            }}</a></li>
                          <li><a href="/plus"><i><img   class="mr-2" width="35" src="../assets/img/icones/menu/add_quote.png"
                                                      :alt="$t('home_page.bouton_devis[6]')"/></i>{{
                              $t('home_page.bouton_devis[6]')
                            }}</a></li>
                          <li class="font-weight-bold" style="cursor:pointer;color: #000;">{{ $t('home_page.entreprise_label') }}</li>
                           <li><a href="/flotte/entreprise"><i><img class="mr-2" width="35" src="../assets/img/icones/menu/cars_quote.png" alt="flotte"/></i>{{ $t('menu.Devis[7]') }}</a></li>
                          <li><a href="/devis/mrp"><i><img   class="mr-2" width="30"
                                                          src="../assets/img/icones/menu/mrp_quote.png"
                                                          alt="devis_mrp"/></i> MRP</a></li>
                          <li><a href="/devis/trc"><i><img   class="mr-2" width="35"
                                                          src="../assets/img/icones/menu/trc_quote.png"
                                                          alt="devis_trc"/></i>TRC</a></li>
                                                          <li><a href="/rcscolaire"><i><img class="mr-2" width="35" src="../assets/img/icones/rcscolaire.png" alt="flotte"/></i>{{ $t('menu.Devis[8]') }}</a></li>
                        </ul>
                      </div>

                      <div class="trigger-simulation mt-3">
                        <span>
                          <img class="mr-3" loading="lazy" src="../assets/img/rocket.png" width="25px"  alt="writing quotes">

                                                  {{ $t('home_page.bouton_simulation_view') }}<i style="font-size: 18px"
                                                                      class="ml-3 fas fa-chevron-down"></i></span>
                        <ul class="devis elevation-24" style="z-index:2">
                          <li><a href="/simulate/devis/auto"><i><img   class="mr-2" width="35"
                                                            src="../assets/img/icones/menu/cars_quote.png"
                                                            :alt="$t('home_page.bouton_devis[1]')"/></i>
                            {{ $t('home_page.bouton_devis[1]') }}</a></li>
                          <li><a href="/simulate/devis/voyage"><i><img   class="mr-2" width="35"
                                                                  src="../assets/img/icones/menu/travel_quote.png"
                                                                  :alt="$t('home_page.bouton_devis[3]')"/></i>
                            {{ $t('home_page.bouton_devis[3]') }}</a></li>
                        </ul>
                      </div>
                    </div>
                    <p class="mt-5" style="font-weight: 500; font-size: 12px; position: absolute; bottom: 0px;"> {{ $t('home_page.cima_agree[0]') }} <span style="color: rgb(255, 164, 9);">{{ $t('home_page.cima_agree[1]') }}</span>{{ $t('home_page.cima_agree[2]') }}</p>
                  </div>
                </div>
              </div>
            </section>

            <!--PARITE DES ASSURANCES-->
            <assuranceSection></assuranceSection>

            <!--PARTIE POURQUOI CHOISIR ASSURAF-->
            <pourquoiSection></pourquoiSection>

            <!--CIMA SECTION ASSURAF-->
             <cimaSection></cimaSection>

            <!--PARITE MARQEE POUR LES LOGOS DES COMPAGNIES-->
            <partenaireSection type="base"></partenaireSection>

            <!--PARTIE MASCOTE KIRRAY-->
            <appMobileSection></appMobileSection>

            <!--PARTIE NOTRE PLATEFORME -->
            <plateformeSection></plateformeSection>

            <!--PARITE CE QUE DISENTS NOS CLIENTS-->
            <testimonialSection></testimonialSection>

            <!--PARITE DEJA ASSURE-->
            <alreadyInsuredSection></alreadyInsuredSection>

            <!--PARITE NEWSLETTER-->
            <newsletterSection></newsletterSection>

            <!--PARITE PAIEMENT-->
            <paymentParterSection></paymentParterSection>
        </div>
    </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import Api from '../services/Api';
import store from "../store/store";
import assuranceSection from '../components/home_component/assurance_section.vue'
import pourquoiSection from '../components/home_component/pourquoi_section.vue'
import partenaireSection from '../components/home_component/partenaire_section.vue'
import appMobileSection from '../components/home_component/app_mobile_section.vue'
import plateformeSection from '../components/home_component/plateforme_section.vue'
import testimonialSection from '../components/home_component/testimonials_section.vue';
import newsletterSection from '../components/home_component/newsletters_section.vue'
import paymentParterSection from '../components/home_component/payment_partner_component.vue'
import cimaSection from '../components/home_component/cima_section.vue'
import alreadyInsuredSection from './home_component/already_insured.vue';


export default {
  name: 'Home',
  components: {
    assuranceSection,
    pourquoiSection,
    partenaireSection,
    appMobileSection,
    plateformeSection,
    testimonialSection,
    newsletterSection,
    paymentParterSection,
    simplebar,
    cimaSection,
    alreadyInsuredSection

  },
  data: () => ({
    email: '',
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
    maketpopup: false, // Pour checker et afficher le popup marketing si configuré
    objetMarketingPopup: null, // Pour stocker les config du popu Marketing à afficher
    To_check_MaketPopup_State: null,
    DevisCountTemp: 0,
    notifications: false,
    overlay: false,
    nom: '',
    prenom: '',
    sujet: '',
  

    message: '',

  }),

  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  methods: {
    checkToken() {
      Api().get('user/check/token')
          .then((resultat) => {
            // verifie si le token exist
            if (!resultat.data.ok) {
              store.state.isUserLoggedIn = false;
              store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          }).catch((err) => {
        // verifie  si le token est expiré
        if (err.response.data.ok === false) {
          store.state.isUserLoggedIn = false;
          store.dispatch("setUser", {});
          store.dispatch("setToken", {});
          this.showLoginForm = true
        }
      });
    },



    ShowMarketPopup() {
      let uripage = this.$route.path;
      Api().post('popup/getpopup', {pagetoshowon: uripage})
          .then(resp => {
            if (resp.data.popup.length > 0) {
              if (!this.To_check_MaketPopup_State) {
                this.maketpopup = true;
                this.objetMarketingPopup = resp.data.popup
              }
            }
          })
    },

    /*=========On check l'etat des cookies au chargement du composant========*/
    /*======pour savoir si le user a deja cliked sur le popup de marketing===*/
    getCookie: function () {
      const match = document.cookie.match(new RegExp('(^| )popup_marketing_checked_Home=([^;]+)'));
      if (typeof match == 'object' && match != null) {
        this.To_check_MaketPopup_State = match
      } else {
        this.To_check_MaketPopup_State = false
      }

    }

  },

  beforeDestroy() {
  window.removeEventListener('scroll', this.handleParallax);
  window.removeEventListener('resize', this.updateParallaxOffsets);
},

  mounted() {
  window.scrollTo(0, 0);
    this.checkToken()
    this.ShowMarketPopup();
    this.getCookie();


    /**
     COPY HERE
     */
    this.handleParallax = () => {
    const dy = window.scrollY;
    this.bgImages.forEach((el, i) => {
        const ot = this.offsetTops[i];
        el.style.backgroundPosition = `50% ${(dy - ot) * this.parallax}px`;
       });
    };
    this.bgImages = Array.from(document.querySelectorAll('.paralax-cover-image, .paralax-cover-image_mobile'));
    this.offsetTops = this.bgImages.map(el => el.offsetTop);
    this.parallax = -0.5;
    window.addEventListener('scroll', this.handleParallax);
    window.addEventListener('resize', this.updateParallaxOffsets);
  }
}
</script>

<style lang="less" scoped>

@import "../assets/less/config";
@import "../assets/css/button.css";
@import "../assets/css/plateforme-home-section.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}



a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}



h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

h3 {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}


.trigger {
  width: 240px;
}

.trigger span {
  width: 240px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger ul.devis li {
  top: 0;
  left: 0;
  width: 240px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger:hover ul.devis {
  transform: scaley(1);
}

.trigger:hover ul.devis a {
  opacity: 1;
}

.trigger-simulation {
  width: 240px;
}

.trigger-simulation span {
  width: 240px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #5B94BC;
  color: #000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger-simulation ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger-simulation ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger-simulation ul.devis li {
  top: 0;
  left: 0;
  width: 240px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger-simulation ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger-simulation ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger-simulation ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger-simulation ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger-simulation:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger-simulation:hover ul.devis {
  transform: scaley(1);
}

.trigger-simulation:hover ul.devis a {
  opacity: 1;
}



.paralax-cover-image {
  background-image: url('../assets/img/home/new_home/new_design.png');
  position: relative;
  background-size: cover;
  background-position: 50%;
  min-height: 650px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  padding: 20px;
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}

.paralax-cover-image p {
  color: rgb(255, 255, 255);
  font-size: 20px;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  //text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.paralax-cover-image {
  background-attachment: fixed;
  background-position: 50% 0;
}


.paralax-cover-image_mobile {
  background-image: url('../assets/img/home/new_home/new_design.png');
  position: relative;
  background-size: cover;
  background-position: 50%;
  min-height: 550px;
  width: 100%;
  margin: 0 0 0;
  padding-bottom: 40px;
  display: flex;
  //padding: 20px;
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}

.paralax-cover-image_mobile p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  padding-bottom: 20Px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  //text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.paralax-cover-image_mobile {
  background-attachment: fixed;
  background-position: 50% 0;
}



.col-text {
  height: 20em;
}

.grid-flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  flex-direction: row;
  -webkit-flex-direction: row;
  -webkit-flex-wrap: wrap;
  -webkit-justify-content: space-around;
}

.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.col-left {
  -webkit-box-ordinal-group: -1;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Aligner-item {
  width: 70%;
  font-size: 20px
}









.rotating-text {
font-size: 70px!important;
line-height: 1.2;
font-weight: bold;
}

.window {
display: inline-block;
overflow: hidden;
flex-grow: 1; /* Allows .window to grow and take up remaining space */
height: 80px!important;
vertical-align: bottom;
}

.window-inner {
display: inline-block;
animation: scroll-text 15s ease-in-out infinite;
color: #ffa409;
}
.window span {
display: block;
}

@keyframes scroll-text {
0% {
  transform: translateY(0%); /* trust */
}
26.66% {
  transform: translateY(calc(-26.66%)); /* Simplement */
}
50.33% {
  transform: translateY(calc(-50.33%)); /* Autrement */
}
75% {
  transform: translateY(calc(-75%)); /* Sereinement */
}
100% {
  transform: translateY(calc(-74.33%)); /* Pour vous (at the end) */
}
}

.container_animation {
width: 100%;
max-width: 50rem;
margin-top: -35px
}

.nowrap {
white-space: nowrap;
}

html {
background: #292929;
color: #edebeb;
padding: 1rem;
}

.rotating-text-mobile {
font-size: 50px!important;
line-height: 1.2;
font-weight: bold;
}

.window-mobile {
display: inline-block;
overflow: hidden;
flex-grow: 1; /* Allows .window to grow and take up remaining space */
height: 50px!important;
vertical-align: bottom;
}

.window-inner-mobile {
display: inline-block;
animation: scroll-text 15s ease-in-out infinite;
color: #ffa409;
}
.window-mobile span {
display: block;
}

@keyframes scroll-text {
0% {
  transform: translateY(0%); /* trust */
}
26.66% {
  transform: translateY(calc(-26.66%)); /* Simplement */
}
50.33% {
  transform: translateY(calc(-50.33%)); /* Autrement */
}
75% {
  transform: translateY(calc(-75%)); /* Sereinement */
}
100% {
  transform: translateY(calc(-74.33%)); /* Pour vous (at the end) */
}
}

.container_animation-mobile {
width: 100%;
max-width: 50rem;
margin-top: -35px
}

.nowrap-mobile {
white-space: nowrap;
}

html-mobile {
background: #292929;
color: #edebeb;
padding: 1rem;
}



</style>

